import React from "react";
import Typography from "@mui/material/Typography";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';

function ComponentStepLabel({ number, title, subtitle }) {

  return (
    <List className="p-16">
      <ListItem alignItems="flex-start" className="p-0 mt-16">
        <ListItemAvatar className="mr-8 mt-0" sx={{ minWidth: 24}}>
          <Avatar
            sx={{ width: 24, height: 24, color: '#6b7280', borderColor: '#6b7280' }}
            className="text-sm font-semibold m-0 border-1 bg-transparent"
          >
            {number}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          className="m-0"
          primary={
            <Typography variant="subtitle1" className="font-semibold">
              {title}
            </Typography>
          }
          secondary={
            subtitle ? subtitle : null
          }
        />
      </ListItem>
    </List>
  );
}

export default ComponentStepLabel;